import * as optimizelySDK from '@optimizely/react-sdk';
import * as uuid from 'uuid';

export const createInstance = () => optimizelySDK.createInstance({
  sdkKey: window.optimizelySDKKey,
});

export const getUuid = () => uuid.v4();

export const getSearch = () => window.location.search;
export const getPathname = () => window.location.pathname;
export const getEnvironment = () => window.ENVIRONMENT;



// WEBPACK FOOTER //
// ./src-react/lib/optimizely/helpers.js